import { useEffect, useState } from "react";
import { Monitor, Smartphone } from "lucide-react";
import { api } from "../../lib/api";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";

const VARS = ["first_name", "referral_count", "referrals_to_next_tier", "next_tier", "reward_tier", "referral_link", "waitlist_status", "otp_code"];

export const EmailEditor = ({ value, onChange, readOnly, promotional = true }) => {
  const [view, setView] = useState("desktop");
  const [html, setHtml] = useState("");
  const set = (k, v) => onChange({ ...value, [k]: v });
  useEffect(() => {
    const t = setTimeout(() => {
      if (!value.subject || !value.html_body) return;
      api.post("/admin/email/preview", { subject: value.subject, preview_text: value.preview_text || "", html_body: value.html_body, text_body: value.text_body || "" }, { params: { promotional } })
        .then((r) => setHtml(r.data.html)).catch(() => {});
    }, 400);
    return () => clearTimeout(t);
  }, [value.subject, value.preview_text, value.html_body, value.text_body, promotional]);
  const ic = "bg-[#080A08] border-[#2A362A] text-sm";
  return (
    <div className="grid xl:grid-cols-2 gap-5" data-testid="email-editor">
      <div className="space-y-4">
        <div><Label>Subject</Label><Input disabled={readOnly} value={value.subject || ""} onChange={(e) => set("subject", e.target.value)} className={`${ic} mt-1.5`} data-testid="editor-subject" /></div>
        <div><Label>Preview text</Label><Input disabled={readOnly} value={value.preview_text || ""} onChange={(e) => set("preview_text", e.target.value)} className={`${ic} mt-1.5`} data-testid="editor-preview-text" /></div>
        <div>
          <Label>HTML body <span className="text-[#7C8A7C] font-normal">(sanitized — scripts and unsafe tags are removed)</span></Label>
          {!readOnly && <div className="flex flex-wrap gap-1.5 my-2">{VARS.map((v) => <button key={v} type="button" onClick={() => set("html_body", `${value.html_body || ""}{${v}}`)} className="font-mono text-[11px] px-2 py-1 rounded border border-[#2A362A] text-[#B7FF3C] hover:bg-[#B7FF3C]/10" data-testid={`var-${v}`}>{`{${v}}`}</button>)}</div>}
          <Textarea disabled={readOnly} value={value.html_body || ""} onChange={(e) => set("html_body", e.target.value)} rows={12} className={`${ic} font-mono text-xs`} data-testid="editor-html" />
        </div>
        <div><Label>Plain-text alternative</Label><Textarea disabled={readOnly} value={value.text_body || ""} onChange={(e) => set("text_body", e.target.value)} rows={6} className={`${ic} mt-1.5 font-mono text-xs`} data-testid="editor-text" /></div>
        <p className="text-xs text-[#7C8A7C]">Missing variables fall back to safe defaults (e.g. first name → "there"). Promotional emails automatically include an unsubscribe link.</p>
      </div>
      <div>
        <div className="flex items-center justify-between mb-2"><p className="eyebrow">Preview (sample data)</p>
          <div className="flex gap-1">{[["desktop", Monitor], ["mobile", Smartphone]].map(([k, I]) => <button key={k} onClick={() => setView(k)} data-testid={`preview-${k}`} className={`p-2 rounded-lg border ${view === k ? "border-[#B7FF3C] text-[#B7FF3C]" : "border-[#2A362A] text-[#7C8A7C]"}`}><I size={16} /></button>)}</div>
        </div>
        <div className="rounded-xl border border-[#1E281E] bg-[#050605] p-3 flex justify-center">
          <iframe title="email-preview" sandbox="" srcDoc={html} className="bg-[#080A08] rounded-lg transition-all" style={{ width: view === "mobile" ? 375 : "100%", height: 640 }} data-testid="email-preview-frame" />
        </div>
      </div>
    </div>
  );
};
